import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { THUMBNAIL } from "../../components/image";
import "../character/character.css";

const Character = () => {
  const [activeIndex, setActiveIndex] = useState(false);

  const handleIconClick = (index) => {
    // if (index === activeIndex) {
    //   setActiveIndex(null);
    // } else {
    //   setActiveIndex(index);
    // }
    setActiveIndex(!activeIndex);
  };

  return (
    <div className="container">
      <div className="overview d-flex align-items-center justify-content-between">
        <div className="title">
          <ion-icon name="accessibility"></ion-icon>
          <span className="text">Characters</span>
        </div>

        <button className="btn-header d-flex align-items-center gap-1">
          <ion-icon name="add-outline"></ion-icon>
          Add
        </button>
      </div>

      <div>
        <div className="tableDataOfCharacter">
          <table>
            <thead>
              <tr>
                <th>No</th>
                <th>Image</th>
                <th>Video URL</th>
                <th>Place</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>
                  <img src={THUMBNAIL} height={50} className="characterImg" />
                </td>
                <td>Play Video</td>
                <td>Login,Story 1</td>
                <td>Active</td>
                <td>
                  <ion-icon
                    name="ellipsis-vertical-outline"
                    id="userAction"
                    // onClick={() => handleIconClick(index)}
                    onClick={() => handleIconClick()}
                    style={{ cursor: "pointer" }}
                  ></ion-icon>
                  {/* {activeIndex === index && ( */}
                  {activeIndex && (
                    <div className="showOption">
                      <NavLink
                        // to={"/view-character"}
                        style={{ textDecoration: "none" }}
                      >
                        <p className="pt-3 d-flex align-items-center gap-2">
                          <ion-icon name="eye-outline"></ion-icon> View
                        </p>
                      </NavLink>
                      <p
                        className="d-flex align-items-center gap-2"
                        style={{ color: "red" }}
                      >
                        <ion-icon name="trash-outline"></ion-icon> Delete
                      </p>
                      <p className="d-flex align-items-center gap-2">
                        <ion-icon name="ban-outline"></ion-icon>Deactivate
                      </p>
                    </div>
                  )}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Character;
